import { useAuth0 as useAuth0Actual } from '@auth0/auth0-react'
import { Auth0Provider as Auth0ProviderActual } from '@auth0/auth0-react'
import Cookies from 'js-cookie'

import { Auth0Provider as Auth0ProviderShim } from './auth0-provider'
import { useAuth0 as useAuth0Shim } from './use-auth0'

const nextAuthCookie = 'enableNextAuth2439163196'
const useNextAuthDefault = 'true'
const enableNextAuth = typeof document !== 'undefined' && (Cookies.get(nextAuthCookie) ?? useNextAuthDefault) == 'true'

// TODO understand the lack of compatibility
const useAuth0: typeof useAuth0Shim = enableNextAuth ? useAuth0Shim : (useAuth0Actual as typeof useAuth0Shim)

const Auth0Provider = enableNextAuth ? Auth0ProviderShim : Auth0ProviderActual

export { useAuth0, Auth0Provider, nextAuthCookie }
